var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"usa-nav__primary-item",class:_vm.data.fields.styleInstructions},[_c('rich-text-renderer',{attrs:{"data":_vm.data.fields.menuLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }